// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginScreen {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}
.LoginScreen .InnerContainer {
  width: 95%;
  height: 90%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1;
  padding-left: 6.25rem;
}
.LoginScreen .InnerContainer .Slider {
  position: relative;
  width: 100%;
  height: 100%;
}
.LoginScreen .InnerContainer .rightBar {
  width: 50%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding-right: 3rem;
}
.LoginScreen .InnerContainer .rightBar img {
  width: 25rem;
  height: 25rem;
}

@media (max-width: 840px) {
  .LoginScreen .InnerContainer {
    padding-left: 0;
  }
}
@media (max-width: 740px) {
  .LoginScreen .InnerContainer {
    justify-content: center;
  }
  .LoginScreen .InnerContainer .Slider {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .LoginScreen .InnerContainer .Slider .loginForm, .LoginScreen .InnerContainer .Slider .forgotPass, .LoginScreen .InnerContainer .Slider .resetPass, .LoginScreen .InnerContainer .Slider .LicenceVerify {
    width: 60%;
  }
  .LoginScreen .InnerContainer .rightBar {
    display: none;
  }
}
@media (max-width: 570px) {
  .LoginScreen .InnerContainer .Slider .loginForm, .LoginScreen .InnerContainer .Slider .forgotPass, .LoginScreen .InnerContainer .Slider .resetPass, .LoginScreen .InnerContainer .Slider .LicenceVerify {
    width: 75%;
  }
  .LoginScreen .InnerContainer .rightBar {
    display: none;
  }
}
@media (max-width: 420px) {
  .LoginScreen .InnerContainer .Slider .loginForm, .LoginScreen .InnerContainer .Slider .forgotPass, .LoginScreen .InnerContainer .Slider .resetPass, .LoginScreen .InnerContainer .Slider .LicenceVerify {
    width: 90%;
    height: 60%;
  }
  .LoginScreen .InnerContainer .rightBar {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Login/Login.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;AACJ;AAAI;EACI,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,qBAAA;AAER;AADQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AAGZ;AADQ;EACI,UAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;AAGZ;AAFY;EACI,YAAA;EACA,aAAA;AAIhB;;AAEA;EAEI;IACE,eAAA;EAAJ;AACF;AAIA;EAGI;IACE,uBAAA;EAJJ;EAKI;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;EAHN;EAIM;IACE,UAAA;EAFR;EAKI;IACE,aAAA;EAHN;AACF;AAOA;EAKQ;IACE,UAAA;EATR;EAYI;IACE,aAAA;EAVN;AACF;AAeA;EAKQ;IACE,UAAA;IACA,WAAA;EAjBR;EAoBI;IACE,aAAA;EAlBN;AACF","sourcesContent":[".LoginScreen{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100vw;\n    height:100vh;\n    .InnerContainer{\n        width: 95%;\n        height: 90%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        z-index: 1;\n        padding-left: 6.25rem;\n        .Slider{\n            position: relative;\n            width: 100%;\n            height: 100%;\n        }\n        .rightBar{\n            width: 50%;\n            height: 100%;\n            display: flex;\n            align-items: flex-end;\n            justify-content: flex-end;\n            padding-right: 3rem;\n            img{\n                width: 25rem;\n                height: 25rem;\n            }\n        }\n    }\n}\n\n@media (max-width: 840px) {\n  .LoginScreen{\n    .InnerContainer{\n      padding-left: 0;\n    }\n  }\n}\n\n@media (max-width: 740px) {\n  \n  .LoginScreen{\n    .InnerContainer{\n      justify-content: center;\n      .Slider{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        .loginForm, .forgotPass, .resetPass, .LicenceVerify{\n          width: 60%;\n        }\n      }\n      .rightBar{\n        display: none;\n      }\n    }\n  }\n}\n@media (max-width: 570px) {\n  \n  .LoginScreen{\n    .InnerContainer{\n      .Slider{\n        .loginForm, .forgotPass, .resetPass, .LicenceVerify{\n          width: 75%;\n        }\n      }\n      .rightBar{\n        display: none;\n      }\n    }\n  }\n}\n\n@media (max-width: 420px) {\n  \n  .LoginScreen{\n    .InnerContainer{\n      .Slider{\n        .loginForm, .forgotPass, .resetPass, .LicenceVerify{\n          width: 90%;\n          height: 60%;\n        }\n      }\n      .rightBar{\n        display: none;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
